import React, { Component } from 'react';
// import { connect } from 'react-redux';

// Component
import EntityList from '../ResponseManage/Lists/EntityList/EntityList';

// Module actions

class EntityListContainer extends Component {
  
  handleUpdateEntityList = (type, list) => {
    this.props.updateEntityList({
      type : type,
      list : list,
    });
  }

  handleShowCreateEntityModal = () => {
    this.props.setCreateEntityModal(true);
  }

  handleRegistUpdateEntity = (id, type) => {
    this.props.setEditTargetEntity({
      entityId : id,
      type : type,
    });
  }

  deleteEntity = (type, id) => {
    this.props.deleteEntity({
      type : type,
      id : id,
    });
  }

  render() {
    return (
      <EntityList
        typeEntityObject={this.props.typeEntityObject} 
        selectedEntityType={this.props.selectedEntityType} 
        updateEntityList={this.handleUpdateEntityList}
        updateEntityDetail={this.props.updateEntityDetail}
        registUpdateEntity={this.handleRegistUpdateEntity}
        topicId={this.props.topicId}
        setEntityTypeSelection={this.props.changeEntityTypeSelection}
        showCreateEntityModal={this.handleShowCreateEntityModal}
        deleteEntity={this.deleteEntity}
        isForInstance={this.props.isForInstance}
        importEntity={this.props.importEntity}
        disableTypes={this.props.disableTypes}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  // selectedEntityType : state.EntityModule.selectedEntityType,
  // typeEntityObject : state.EntityModule.typeEntityObject,
  // topicId : state.topic.selectedTopicId,
})

const mapDispatchToProps = (dispatch) => ({
  // updateEntityList : (arg) => {dispatch(updateEntityList(arg))},
  // changeEntityTypeSelection : (value) => {dispatch(changeEntityTypeSelection(value))},
  // updateEntityDetail : (entity) => {dispatch(updateEntityDetail(entity))},
  // setCreateEntityModal : (value) => {dispatch(setCreateEntityModal(value))},
  // deleteEntity : (arg) => {dispatch(deleteEntity(arg))},
  // setEditTargetEntity : (arg) => {dispatch(setEditTargetEntity(arg))},
})

export default EntityListContainer;